import SurveyItemBase from './SurveyItemBase';
export default class MultipleChoiceQuestion extends SurveyItemBase {
    constructor(wrapper) {
        super(wrapper);
        this.isChecked = (currentAnswer) => {
            let input = currentAnswer.querySelector('input[type="radio"]');
            if (input) {
                return input.checked;
            }
            return false;
        };
        this.checkInput = (currentAnswer, checked = true) => {
            let input = currentAnswer.querySelector('input[type="radio"]');
            if (input) {
                input.checked = checked;
                if (checked === true) {
                    // trigger change event
                    input.dispatchEvent(new Event("change"));
                }
            }
        };
        this.unSelect = () => {
            this.answerElements.forEach(element => {
                if (element.classList.contains("active")) {
                    element.classList.remove("active");
                    this.checkInput(element, false);
                }
            });
        };
        //private getAnswerValue = (currentAnswer: HTMLElement) => {
        //    let input = currentAnswer.querySelector<HTMLInputElement>('input[type="radio"]');
        //    if (input) {
        //        return input.value;
        //    }
        //    return '';
        //}
        this.triggerJqueryValidation = (currentAnswer, checked = true) => {
            let input = currentAnswer.querySelector('input[type="radio"]');
            if (input) {
                // send this event to jquery validation to validate this input
                input.dispatchEvent(new CustomEvent('validate', { bubbles: true }));
            }
        };
        this.init = () => {
            // survey answer click event
            this.answerElements.forEach(element => {
                // if include other answer
                const otherAnswerTextField = element.querySelector(".survey-item-answer-other");
                if (otherAnswerTextField) {
                    // set value of other text field into current choice
                    otherAnswerTextField.addEventListener("change", (e) => {
                        let input = element.querySelector('input[type="radio"]');
                        if (input) {
                            input.value = otherAnswerTextField.value;
                        }
                    });
                }
                element.addEventListener("click", (e) => {
                    e.preventDefault();
                    // remove active class on other answers
                    this.unSelect();
                    // add active state to current item
                    element.classList.add("active");
                    // check 
                    this.checkInput(element, true);
                    // trigger event
                    //this.triggerSelectValue(this.getAnswerValue(element));
                    // jquery validation
                    this.triggerJqueryValidation(element);
                });
            });
        };
        this.answerElements = [].slice.call(this.wrapper.querySelectorAll(".survey-item-answer"));
        // check default state
        this.answerElements.forEach(element => {
            if (this.isChecked(element)) {
                // add active state to current item
                element.classList.add("active");
                // trigger event
                //this.triggerSelectValue(this.getAnswerValue(element));
            }
        });
    }
}
;
